import styled from 'styled-components';

export const MainTableContainer = styled.div`
  width: 100%;
  tr.ant-table-expanded-row > td {
    padding: 0;
  }

  .ant-table-thead {
    tr {
      .ant-table-cell:first-child {
        :before {
          display: none;
        }
      }
    }
  }
`;

export const TableRowEdit = styled.div`
  width: 100%;
  display: flex;
`;
